<template>
<div>
    <div v-if="buttonTop" class="mb-3">
        <b-button v-if="checkUserPermission('attest', 'can_add')" @click="addNew = !addNew" :variant="addNew ? 'danger' : 'primary'"><i :class="[addNew ? 'fa-solid fa-ban' : 'fa-solid fa-plus']"></i> {{ addNew ? 'Cancel' : 'Add' }}</b-button>
        <b-collapse id="add" v-model="addNew" variant="primary">
            <AttestsForm class="mt-3" :callback="callback" :small="small" @created="addNew = false" :refresh="addNew" />
        </b-collapse>
    </div>
    <b-overlay :show="confirm" no-wrap @shown="onShown">
        <template #overlay>
            <div ref="dialog" tabindex="-1" role="dialog" aria-modal="false" aria-labelledby="form-confirm-label">
                <p class="text-center">
                    <i class="fa-light fa-xmark text-danger"></i> <strong class="text-danger">DELETE ATTEST INFO ON {{ toLocaleDate(selected?.created) }} </strong>
                </p>
                <div class="text-center">
                    <b-button variant="outline-danger" class="mr-3" @click="onCancel">Cancel</b-button>
                    <b-button variant="outline-success" @click="onConfirmed(selected)">Confirm</b-button>
                </div>
            </div>
        </template>
    </b-overlay>
    <b-overlay 
        :show="$store.getters['loading/isLoading']('attests')"
        rounded="sm"
        variant="light"
        spinner-variant="dark"
        :opacity="0.80"
        blur="2px">
        <b-card-body class="p-0">
            <b-table
                ref="table"
                class="m-0"
                responsive
                stacked="sm"
                show-empty
                striped
                hover
                :fixed="fixed"
                :small="small"
                :borderless="borderless"
                primary-key="id"
                :current-page="currentPage"
                :per-page="perPage"
                :items="items"
                :fields="fields"
                :no-sort-reset="true"
                :sort-by.sync="sortedBy"
                :sort-desc.sync="sortedDesc"
                :no-border-collapse="false">

                <template v-slot:cell(height)="data">
                    <span :class="{ 'small font-italic text-muted': !data.value }">{{ data.value ? data.value+" cm" : 'n/a' }} </span>
                </template>

                <template v-slot:cell(actions)="row">
                    <b-button-group size="sm">
                        <b-button v-if="checkUserPermission('attest', 'can_execute')" variant="secondary" v-b-tooltip.hover title="Coming Soon"><i class="fa-solid fa-print"></i></b-button>
                        
                        <b-button variant="primary" @click="row.toggleDetails"><i class="fa-solid fa-ellipsis-h"></i></b-button>

                        <b-button v-if="checkUserPermission('attest', 'can_delete')" variant="danger" @click="onRemoveItem(row.item)"><i class="fa-light fa-xmark"></i></b-button>
                    </b-button-group>
                </template>

                <template #row-details="row">
                    <template v-if="row.item.dates.length > 0">
                      <b-list-group>
                        <b-list-group-item v-for="(date, index) in row.item.dates" :key="index" class="d-flex justify-content-between align-items-center">
                          <span class="text-muted small">{{ toFullDate(date.id) }}</span>
                        </b-list-group-item>
                      </b-list-group>
                    </template>

                    <template v-else>
                        <template v-if="row.item.from_date && row.item.until_date">
                            <span class="text-muted small">{{toFullDate(row.item.from_date)}} - {{toFullDate(row.item.until_date) }}</span>
                        </template>
                        <template v-else>
                            <span class="small text-muted text-center">n/a</span>
                        </template>
                    </template>

                </template>

                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>

                <template v-slot:empty="scope">
                    <div class="small text-muted text-center my-2">
                        <span>n/a</span>
                    </div>
                </template>
                <template v-slot:custom-foot="scope">
                    <b-tr class="border-top">
                        <b-td colspan="2" class="align-middle" variant="light" style="background: #fff;">
                            Showing {{ startIndex }} to {{ endIndex }} of {{ totalRows }}
                        </b-td>
                        <b-td colspan="2" class="text-right align-middle" variant="light" style="background: #fff;">
                            <b-pagination class="m-0" prev-text="Prev" next-text="Next" hide-goto-end-buttons align="right" :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                        </b-td>
                    </b-tr>
                </template>
            </b-table>
                <b-card-footer v-if="!buttonTop">
                    <b-button v-if="checkUserPermission('attest', 'can_add')" @click="addNew = !addNew" :variant="addNew ? 'danger' : 'primary'"><i :class="[addNew ? 'fa-solid fa-ban' : 'fa-solid fa-plus']"></i> {{ addNew ? 'Cancel' : 'Add' }}</b-button>
                    <b-collapse id="add" v-model="addNew" variant="primary">
                        <AttestsForm class="mt-3" :callback="callback" :small="small" @created="addNew = false" :refresh="addNew"/>
                    </b-collapse>
                </b-card-footer>
            </b-card-body>
        </b-overlay>
    </div>
</template>
<script>
import ComponentBaseExtension from "@/core/components/ComponentBaseExtension"
import { mapGetters, mapState, mapActions } from "vuex"

import AttestsForm from './AttestsForm'

import printJS from 'print-js'
import cloneDeep from 'lodash/cloneDeep'

export default ComponentBaseExtension.extend({
    name: "attests-base",
    components: {
        AttestsForm
    },
    data() {
        return {
            addNew: false,
            fields: [
                { key: 'attest_date', label: 'Date/Time', class: {"align-middle" : true, "small": this.small }, formatter: (value) => this.toLocaleDate(value) },
                { key: 'sum_days', label: 'Days', class: {"align-middle" : true, "text-center": true, "small": this.small } },
                { key: 'company_name', label: 'Company', class: {"align-middle" : true, "text-center": true, "small": this.small }, formatter: (value) => value || 'n/a' },                
                { key: "actions", label: "", class: {"align-middle" : true, "text-right": true, "small": this.small } },
            ],

            currentPage: 1,
            perPage: 5,
            sortedBy: 'attest_date',
            sortedDesc: true,

            confirm: false,
            selected: null,
        }
    },
    computed: {
        ...mapGetters('health', ['getPatientAttests']),
        items() {
            return cloneDeep(this.getPatientAttests())
        },
        totalRows() {
            return this.items.length
        },
        startIndex() {
            return (this.currentPage - 1) * this.perPage + 1
        },
        endIndex() {
            var end = this.totalRows
            if (this.perPage < this.totalRows) {
                end = this.perPage * this.currentPage
                if (end > this.totalRows) {
                    end = this.totalRows
                }
            }
            return end
        }
    },
    methods: {
        ...mapActions('health', ['getAttestsForCurrentPatient', 'deletePatientAttest', 'attesToHTMLById']),
        async loadForPatient(patient) {
            await this.getAttestsForCurrentPatient()
        },
        onRemoveItem(item) {
            this.confirm = true
            this.selected = item
        },
        onConfirmed(item) {
            this.deletePatientAttest(item.id).then(() => {
                this.notify("Patient attest removed", "Patient attest was removed successfully")
                this.confirm = false
                this.processing = false
                this.selected = null

            })
            .catch(errors => {
                this.notify("Error", "Something went wrong", 'danger')
                this.confirm = false
                this.selected = null
            })
        },
        onShown() {
            // Focus the dialog prompt
            this.$refs.dialog?.focus()
        },
        onCancel() {
            this.confirm = false
            this.selected = null
        },
        async printRow(row) {
            const attest = await this.attesToHTMLById(row.item.id)
            printJS({
                printable: attest,
                type: 'raw-html'
            })
        }
    }
})
</script>